export const faqs = [
  {
    question: 'How long does a typical repair take?',
    answer:
      "Most repairs, including screen replacements and battery changes, are completed the same day - often within 1-2 hours. More complex repairs like water damage restoration may take 24-48 hours. We'll give you an accurate time estimate when you bring in your device.",
  },
  {
    question: 'Do you offer a warranty on repairs?',
    answer:
      'Yes! We provide an industry-leading warranty on all repairs and parts. Your repair is covered against defects and workmanship issues, giving you complete peace of mind.',
  },
  {
    question: 'Will my data be safe during the repair?',
    answer:
      "Absolutely. We prioritize your privacy and data security. In most cases, repairs don't require accessing your data. However, we always recommend backing up your device before any repair as a best practice.",
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept all major credit cards (Visa, Mastercard, American Express, Discover), digital payments (Apple Pay, Google Pay, Samsung Pay), P2P payments (Zelle, Cash App, Venmo, PayPal), and cash. We offer financing through Afterpay and Lease-to-own through Acima Leasing.',
  },
  {
    question: 'Do you use genuine parts?',
    answer:
      'Yes! We use genuine OEM and high-quality parts for all repairs. Our OEM certified technicians ensure your device is repaired to manufacturer standards, maintaining its performance and longevity.',
  },
  {
    question: 'Can I get a quote before committing to a repair?',
    answer:
      'Of course! Click the "Get a Repair Quote" button at the top of the page or call us at (224) 419-9922. We\'ll provide a free, no-obligation quote. There are no hidden fees - the price we quote is the price you pay.',
  },
];
